<template>
  <div class="MaterialListHeader" :class="{'MaterialListHeader--grid-view': gridView}">
    <div v-if="!gridView" class="MaterialListHeader__list">
      <div
        class="MaterialListHeader__item"
        :class="{
          'MaterialListHeader__item--active': checkIsActive(sort.value),
          'MaterialListHeader__item--negative': value.negative,
        }"
        v-for="sort in sortOptions"
        :key="sort.value"
        @click="select(sort.value)"
      >
        <div class="MaterialListHeader__item-title">
          {{ sort.title }}
        </div>
        <div class="MaterialListHeader__item-arrow" v-html="sortIcon" />
      </div>
    </div>
    <div class="MaterialListHeader__sort-select" v-else>
      <SelectCustom
        :list="gridSortOptions"
        :name="$t('Notifications.sortBy')"
        v-model="modelSort"
        :is-multiple="false"
        :show-count="false"
        display-selected
        round
      />
    </div>
  </div>
</template>

<script>
import sortIcon from '@/assets/icons/sort-arrow.svg?raw'
import { mapState } from 'vuex'
import SelectCustom from '@/components/form/SelectCustom.vue'

export default {
  name: 'MaterialListHeader',
  components: { SelectCustom },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    sortOptions: Array,
    gridView: Boolean,
    value: {
      type: Object,
      default: () => ({
        value: null,
        negative: false,
      }),
    },
  },
  data: (vm) => ({
    sortIcon,
  }),
  methods: {
    select(value) {
      const active = this.checkIsActive(value)
      const sort = active && this.value.negative ? null : value
      this.$emit('change', {
        sort,
        negative: sort ? active : false,
      })
    },
    checkIsActive(value) {
      return this.value.sort === value
    },
  },
  computed: {
    modelSort: {
      get() {
        console.log(this.value);
        return this.value?.id ? [this.value.id] : null;
      },
      set([val]) {
        const item = this.gridSortOptions.find(el => el.id === val);
        console.log(val, item);
        this.$emit('change', item)
      }
    },
    gridSortOptions() {
      const newSort = [];
      this.sortOptions.forEach((el,i) => {
        newSort.push({negative: true, sort: el.value, id: el.id, title: `${el.title} (${this.$t('a-z')})`});
        newSort.push({negative: false, sort: `-${el.value}`, id: `-${el.id}`, title: `${el.title} (${this.$t('z-a')})`});
      })
      return newSort
    }
  }
}
</script>

<style lang="scss">
.MaterialListHeader {
  margin-bottom: 20px;
  padding-right: 70px;

  &--grid-view {
    padding-right: 0;
  }

  &__list {
    display: grid;
    grid-template-columns: 1fr 100px 230px 120px;
    grid-gap: 50px;
  }

  &__sort-select {
    display: flex;
    justify-content: flex-end;

    select {
      width: fit-content;
      min-width: 193px;
    }

    .select-custom {
      min-width: 200px;
    }

    .select-custom__list {

      .item:nth-child(2) {
        border-bottom: 1px solid #F2F2F2;
        padding-bottom: 15px;
      }
      .item:nth-child(4) {
        border-bottom: 1px solid #F2F2F2;
        padding-bottom: 15px;
      }
      .item:nth-child(6) {
        border-bottom: 1px solid #F2F2F2;
        padding-bottom: 15px;
      }
    }
  }

  &__item {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    &--active & {
      &-title {
        color: #003882;
      }

      &-arrow {
        path {
          stroke: #003882;
        }
      }
    }

    &--negative & {
      &-arrow {
        transform: rotate(180deg);
      }
    }

    &-title {
      margin-right: 8px;

      font-weight: 700;
      font-size: 12px;
      line-height: 147.5%;
      color: #ccd7e6;
    }

    &-arrow {
      display: inline-flex;
    }
  }
}
</style>
